const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'spirit',
  tiles: {
    ceiling1: 0,
    ceiling2: 1,
    ceiling3: 2,
    ceiling4: 3,
    ceiling5: 4,
    ceiling6: 5,
    ceiling7: 6,
    door: 7,
    exit: 8,
    floor: 9,
    floor_fade: 10,
    floor_indoor: 11,
    wall1: 12,
    wall2: 13,
    wall3: 14,
    wall4: 15
  },
  uidata: {
    rects: [
      vec4(8/1024,8/64,40/1024,40/64),
      vec4(56/1024,8/64,88/1024,40/64),
      vec4(104/1024,8/64,136/1024,40/64),
      vec4(152/1024,8/64,184/1024,40/64),
      vec4(200/1024,8/64,232/1024,40/64),
      vec4(248/1024,8/64,280/1024,40/64),
      vec4(296/1024,8/64,328/1024,40/64),
      vec4(344/1024,8/64,376/1024,40/64),
      vec4(392/1024,8/64,424/1024,40/64),
      vec4(440/1024,8/64,472/1024,40/64),
      vec4(488/1024,8/64,520/1024,40/64),
      vec4(536/1024,8/64,568/1024,40/64),
      vec4(584/1024,8/64,616/1024,40/64),
      vec4(632/1024,8/64,664/1024,40/64),
      vec4(680/1024,8/64,712/1024,40/64),
      vec4(728/1024,8/64,760/1024,40/64)
    ]
  },
  layers: undefined,
  FRAME_CEILING1: 0,
  FRAME_CEILING2: 1,
  FRAME_CEILING3: 2,
  FRAME_CEILING4: 3,
  FRAME_CEILING5: 4,
  FRAME_CEILING6: 5,
  FRAME_CEILING7: 6,
  FRAME_DOOR: 7,
  FRAME_EXIT: 8,
  FRAME_FLOOR: 9,
  FRAME_FLOOR_FADE: 10,
  FRAME_FLOOR_INDOOR: 11,
  FRAME_WALL1: 12,
  FRAME_WALL2: 13,
  FRAME_WALL3: 14,
  FRAME_WALL4: 15
};
spritesheetRegister(module.exports);
